import type { AccountForChildEligibilityDetails } from '@generated-types';
import { createContext } from 'react';

export interface AccountApplicationContextType {
    selectedChildEligibility: AccountForChildEligibilityDetails | null;
    applicantParentEmail: string | null;
    notifyApproverParentOnPhoneNumber: string | null;
    applicantParentHasGivenConsent: boolean;
}

const initialAccountApplicationContext = {
    selectedChildEligibility: null,
    applicantParentEmail: null,
    notifyApproverParentOnPhoneNumber: null,
    applicantParentHasGivenConsent: false,
};

export const AccountApplicationContext = createContext<AccountApplicationContextType>(initialAccountApplicationContext);
